import {
  COMPONENT_VALUE_TYPES as types,
  FONT_SIZES
} from 'shared/constants';

const propsSchema = [
  {
    key: 'background_color',
    label: 'Background Color',
    type: types.COLOR_PICKER,
  },
  {
    key: 'columns',
    label: 'Columns',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'font',
    label: 'Font',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title Font',
        type: types.OBJECT,
        children: [
          {
            key: 'font_color',
            label: 'Font Color',
            type: types.COLOR_PICKER,
          },
          {
            key: 'font_size',
            label: 'Font Size',
            type: types.ENUM,
            options: FONT_SIZES
          },
          {
            key: 'opacity',
            label: 'Opacity',
            type: types.TEXT
          },
        ]
      },
      {
        key: 'description',
        label: 'Description Font',
        type: types.OBJECT,
        children: [
          {
            key: 'font_color',
            label: 'Font Color',
            type: types.COLOR_PICKER,
          },
          {
            key: 'font_size',
            label: 'Font Size',
            type: types.ENUM,
            options: FONT_SIZES
          },
          {
            key: 'opacity',
            label: 'Opacity',
            type: types.TEXT
          },
        ]
      }
    ]
  },
  {
    key: 'separator',
    label: 'Separator',
    type: types.OBJECT,
    children: [
      {
        key: 'color',
        label: 'Color',
        type: types.COLOR_PICKER,
      },
      {
        key: 'opacity',
        label: 'Opacity',
        type: types.TEXT,
      },
      {
        key: 'width',
        label: 'Width (px)',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'padding',
    label: 'Padding',
    type: types.OBJECT,
    children: [
      {
        key: 'top',
        label: 'Top padding',
        type: types.TEXT
      },
      {
        key: 'outer',
        label: 'Outer left/right padding',
        type: types.TEXT
      },
      {
        key: 'inner',
        label: 'Inner left/right padding',
        type: types.TEXT
      },
      {
        key: 'bottom',
        label: 'Bottom padding',
        type: types.TEXT
      },
    ]
  },

];

const defaultProps = {
  background_color: '#1B1B1B',
  columns: [
    { title: 'Title', description: 'Description' },
    { title: 'Title', description: 'Description' },
    { title: 'Title', description: 'Description' },
    { title: 'Title', description: 'Description' },
  ],
  font: {
    title: {
      font_color: 'white',
      font_size: '13px',
      opacity: '0.7',
    },
    description: {
      font_color: 'white',
      font_size: '13px',
      opacity: '0.7',
    }
  },
  separator: {
    color: '#979797',
    opacity: '0.35',
    width: '1px'
  },
  padding: {
    top: '0px',
    outer: '0px',
    inner: '0px',
    bottom: '0px',
  }
};

export default {
  title: 'Column Highlight',
  id: 'ColumnHighlight',
  propsSchema,
  defaultProps
};
